import React from 'react';
import { observer, inject } from 'mobx-react';

import { Spinner } from 'components';
import { SettingsSection } from 'legacyComponents/styled/lib';

import { GroupsAppManager } from 'apps/group/appManager';
import { GroupSection } from 'apps/group/views/groupSection';
import { LinkSection } from 'apps/group/views/linkSection';

@inject('routerStore')
@observer
export class TeamSettings extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new GroupsAppManager(null, this.props);
  }

  render() {
    if (this.appManager.loading) {
      return (
        <SettingsSection>
          <Spinner margin='30px auto' />
        </SettingsSection>
      );
    }
    const groups = this.appManager.groups?.sortedGroups.map(group => (
      <GroupSection group={group} key={group.upstream.id} />
    ));
    return (
      <>
        <SettingsSection>
          <LinkSection app={this.appManager.inviteLink} type='organisation' />
        </SettingsSection>
        <SettingsSection>{groups}</SettingsSection>
      </>
    );
  }
}
